import React from 'react';
import ChallengeSnippets from '../components/challenges/challengeDetailSections/challengeCFNTemplate/ChallengeSnippets';

export const ChallengesSnippetsPage: React.FC = () => {
  return <ChallengeSnippets />;
};
